/**
 * Product card image slideshow (prev/next + optional hover peek of next slide)
 */
(function () {
  "use strict";

  if (window.cardProductSlideshowInitialized) {
    return;
  }
  window.cardProductSlideshowInitialized = true;

  const initialized = new WeakSet();

  const CARD_MEDIA_AREA_SLIDESHOW_NAV_VISIBLE =
    "product-card__media-area--slideshow-nav-visible";
  const CARD_MEDIA_AREA_CAROUSEL_ACTIVE_ATTR =
    "data-slideshow-nav-carousel-active";
  let slideshowNavMobileDismissBound = false;

  function isMobileCompactSlideshowViewport() {
    return (
      typeof window.matchMedia === "function" &&
      window.matchMedia("(max-width: 749px)").matches
    );
  }

  function collapseAllCompactSlideshowNavVisibility() {
    document
      .querySelectorAll(".product-card__media-area." + CARD_MEDIA_AREA_SLIDESHOW_NAV_VISIBLE)
      .forEach(function (mediaArea) {
        mediaArea.classList.remove(CARD_MEDIA_AREA_SLIDESHOW_NAV_VISIBLE);
        mediaArea.removeAttribute(CARD_MEDIA_AREA_CAROUSEL_ACTIVE_ATTR);
      });
  }

  function bindSlideshowNavCompactDismissGlobalsOnce() {
    if (slideshowNavMobileDismissBound) {
      return;
    }
    slideshowNavMobileDismissBound = true;

    document.addEventListener(
      "click",
      function (e) {
        if (!isMobileCompactSlideshowViewport()) {
          return;
        }
        if (e.target.closest(".product-card__slideshow-btn")) {
          return;
        }
        document
          .querySelectorAll(".product-card__media-area." + CARD_MEDIA_AREA_SLIDESHOW_NAV_VISIBLE)
          .forEach(function (mediaArea) {
            if (!mediaArea.contains(e.target)) {
              if (mediaArea.hasAttribute(CARD_MEDIA_AREA_CAROUSEL_ACTIVE_ATTR)) {
                return;
              }
              mediaArea.classList.remove(CARD_MEDIA_AREA_SLIDESHOW_NAV_VISIBLE);
            }
          });
      },
      false
    );

    var mq749 = window.matchMedia("(max-width: 749px)");
    function onMq749BeyondCompact() {
      if (!mq749.matches) {
        collapseAllCompactSlideshowNavVisibility();
      }
    }
    if (typeof mq749.addEventListener === "function") {
      mq749.addEventListener("change", onMq749BeyondCompact);
    } else if (typeof mq749.addListener === "function") {
      mq749.addListener(onMq749BeyondCompact);
    }
  }

  function supportsFinePointerHover() {
    return (
      typeof window.matchMedia === "function" &&
      window.matchMedia("(hover: hover)").matches &&
      window.matchMedia("(pointer: fine)").matches
    );
  }

  // Distance a finger must travel before we treat the gesture as an
  // intentional sideways drag (reveal nav) rather than a tap (navigate).
  // Kept above the ~10px touch-slop so normal taps — which jitter a few
  // px — still navigate on the first tap instead of being swallowed.
  var DRAG_REVEAL_NAV_PX = 28;

  /** Compact mobile: reveal slideshow nav after small drag only (never tap); suppress one link click after drag. */
  function bindCompactMobileSlideshowNavReveal(mediaArea) {
    mediaArea.addEventListener(
      "click",
      function onCompactMobileSuppressSyntheticLink(ev) {
        if (!isMobileCompactSlideshowViewport()) {
          return;
        }
        if (ev.target.closest(".product-card__slideshow-btn")) {
          return;
        }

        if (mediaArea.dataset.suppressSlideshowMediaLinkOnce === "1") {
          delete mediaArea.dataset.suppressSlideshowMediaLinkOnce;
          if (ev.target.closest(".product-card__media-link")) {
            ev.preventDefault();
            ev.stopImmediatePropagation();
          }
        }
      },
      true
    );

    var dragRevealState = null;

    mediaArea.addEventListener(
      "pointerdown",
      function onCompactDragRevealPointerDown(pev) {
        if (!isMobileCompactSlideshowViewport()) {
          return;
        }
        if (pev.target.closest(".product-card__slideshow-btn")) {
          return;
        }
        if (mediaArea.classList.contains(CARD_MEDIA_AREA_SLIDESHOW_NAV_VISIBLE)) {
          return;
        }

        dragRevealState = {
          id: pev.pointerId,
          x: pev.clientX,
          y: pev.clientY,
        };

        function cleanupWindowListeners() {
          window.removeEventListener("pointermove", onRevealPointerMove);
          window.removeEventListener("pointerup", onRevealPointerUp);
          window.removeEventListener("pointercancel", onRevealPointerUp);
        }

        function onRevealPointerMove(mev) {
          if (!dragRevealState || mev.pointerId !== dragRevealState.id) {
            return;
          }
          var dx = mev.clientX - dragRevealState.x;
          var dy = mev.clientY - dragRevealState.y;
          var absDx = Math.abs(dx);
          var absDy = Math.abs(dy);

          // Vertical-dominant movement past threshold: treat as page scroll.
          // Drop tracking (never reveal nav / never suppress the link click).
          // Do not preventDefault — this code must never block scrolling.
          if (absDy >= DRAG_REVEAL_NAV_PX && absDy >= absDx) {
            dragRevealState = null;
            cleanupWindowListeners();
            return;
          }

          // Only a horizontal-dominant drag past the threshold reveals the
          // nav. This lets vertical page scrolls (which start on a card)
          // fall through as normal scrolling instead of revealing arrows
          // and suppressing the tap.
          if (absDx >= DRAG_REVEAL_NAV_PX && absDx > absDy) {
            var hostSlider = mediaArea.closest("card-product-slider");
            if (hostSlider) {
              hostSlider
                .querySelectorAll(
                  ".product-card__media-area." +
                    CARD_MEDIA_AREA_SLIDESHOW_NAV_VISIBLE
                )
                .forEach(function (otherArea) {
                  if (otherArea !== mediaArea) {
                    // Keep carousel-active (center-view) arrows; only clear
                    // peer drag-revealed nav without that attr.
                    if (
                      !otherArea.hasAttribute(
                        CARD_MEDIA_AREA_CAROUSEL_ACTIVE_ATTR
                      )
                    ) {
                      otherArea.classList.remove(
                        CARD_MEDIA_AREA_SLIDESHOW_NAV_VISIBLE
                      );
                    }
                  }
                });
            }
            mediaArea.classList.add(CARD_MEDIA_AREA_SLIDESHOW_NAV_VISIBLE);
            /* After drag, suppress the next synthesized click so we don't navigate away */
            mediaArea.dataset.suppressSlideshowMediaLinkOnce = "1";
            dragRevealState = null;
            cleanupWindowListeners();
          }
        }

        function onRevealPointerUp(uev) {
          if (!dragRevealState || uev.pointerId !== dragRevealState.id) {
            return;
          }
          dragRevealState = null;
          cleanupWindowListeners();
        }

        window.addEventListener("pointermove", onRevealPointerMove, {
          passive: true,
        });
        window.addEventListener("pointerup", onRevealPointerUp);
        window.addEventListener("pointercancel", onRevealPointerUp);
      },
      true
    );
  }

  function getSlides(media) {
    return [...media.querySelectorAll("img.product-card__slide")];
  }

  function updateSlides(slides, index, liveEl) {
    slides.forEach((img, i) => {
      img.classList.toggle("product-card__slide--active", i === index);
      img.classList.remove("product-card__slide--peek");
      img.setAttribute("aria-hidden", i === index ? "false" : "true");
    });
    if (liveEl && slides.length) {
      liveEl.textContent = `${index + 1} / ${slides.length}`;
    }
  }

  function initCard(card) {
    if (!(card instanceof HTMLElement) || initialized.has(card)) {
      return;
    }

    const media = card.querySelector(".product-card__media.product-card__slideshow");
    if (!media) {
      return;
    }

    const slides = getSlides(media);
    if (slides.length < 2) {
      initialized.add(card);
      return;
    }

    initialized.add(card);

    const area = card.querySelector(".product-card__media-area");
    const prevBtn = card.querySelector(".product-card__slideshow-btn--prev");
    const nextBtn = card.querySelector(".product-card__slideshow-btn--next");
    const liveEl = card.querySelector(
      '.product-card__media-area [aria-live="polite"]'
    );

    let index = slides.findIndex((el) =>
      el.classList.contains("product-card__slide--active")
    );
    if (index < 0) {
      index = 0;
    }

    updateSlides(slides, index, liveEl);

    function clearPeek() {
      slides.forEach((img) => img.classList.remove("product-card__slide--peek"));
    }

    function step(delta) {
      index = (index + delta + slides.length) % slides.length;
      clearPeek();
      updateSlides(slides, index, liveEl);
    }

    function applyPeek() {
      if (!media.dataset.slideshowHoverPeek) {
        return;
      }
      clearPeek();
      const next = slides[(index + 1) % slides.length];
      if (next) {
        next.classList.add("product-card__slide--peek");
      }
    }

    function onReset() {
      index = 0;
      clearPeek();
      updateSlides(slides, index, liveEl);
    }

    const slideshowNav = card.querySelector(".product-card__slideshow-nav");
    /** Shared by prev/next: stale true would swallow the following click after hover paths. */
    const navPointerState = { suppressNextClick: false };

    /** When hover-peek shows the upcoming slide, "Next" must land on it — not advance again (double-step). */
    function tryCommitPeekToIndex() {
      const nextIdx = (index + 1) % slides.length;
      const nextSlide = slides[nextIdx];
      if (
        nextSlide &&
        nextSlide.classList.contains("product-card__slide--peek")
      ) {
        index = nextIdx;
        return true;
      }
      return false;
    }

    /** Next: finalize peek target if visible; otherwise move one slide. Prev: always one step back. */
    function navigateSlides(delta) {
      if (
        delta === 1 &&
        tryCommitPeekToIndex()
      ) {
        clearPeek();
        updateSlides(slides, index, liveEl);
        return;
      }
      step(delta);
    }

    function syncNavFromPointer() {
      navPointerState.suppressNextClick = false;
      tryCommitPeekToIndex();
      clearPeek();
      updateSlides(slides, index, liveEl);
    }

    function syncNavFromKeyboard() {
      navPointerState.suppressNextClick = false;
      clearPeek();
      updateSlides(slides, index, liveEl);
    }

    if (slideshowNav && area) {
      bindCompactMobileSlideshowNavReveal(area);
    }

    if (slideshowNav) {
      slideshowNav.addEventListener("mouseenter", syncNavFromPointer);
      slideshowNav.addEventListener("focusin", syncNavFromKeyboard);
    }

    /**
     * Primary pointer: advance on pointerdown + preventDefault so focus does not
     * move to the button before the row scroll logic runs (see card-product-slider).
     * Keyboard: click (no prior pointerdown) or Enter/Space advances once.
     */
    function bindNavButton(btn, delta) {
      if (!btn) return;

      btn.addEventListener("pointerdown", (e) => {
        if (!e.isPrimary) return;
        if (
          e.pointerType !== "mouse" &&
          e.pointerType !== "pen" &&
          e.pointerType !== "touch"
        ) {
          return;
        }
        navPointerState.suppressNextClick = true;
        e.preventDefault();
        e.stopPropagation();
        navigateSlides(delta);
      });

      btn.addEventListener("pointercancel", () => {
        navPointerState.suppressNextClick = false;
      });

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (navPointerState.suppressNextClick) {
          navPointerState.suppressNextClick = false;
          return;
        }
        navigateSlides(delta);
      });

      btn.addEventListener("keydown", (e) => {
        if (e.key !== "Enter" && e.key !== " ") return;
        e.preventDefault();
        e.stopPropagation();
        navigateSlides(delta);
      });
    }

    bindNavButton(prevBtn, -1);
    bindNavButton(nextBtn, 1);

    if (
      area &&
      media.dataset.slideshowHoverPeek &&
      supportsFinePointerHover()
    ) {
      area.addEventListener("mouseenter", applyPeek);
      area.addEventListener("mouseleave", clearPeek);
    }

    card.addEventListener("product-card:slideshow-reset", onReset);
  }

  window.resetProductCardSlideshow = function (card) {
    if (!card) {
      return;
    }
    card.dispatchEvent(
      new CustomEvent("product-card:slideshow-reset", { bubbles: false })
    );
  };

  function scan(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const cards =
      root && root.nodeType === 1 && root.matches && root.matches("product-card")
        ? [root]
        : scope.querySelectorAll("product-card");

    cards.forEach((card) => initCard(card));
  }

  function onReady() {
    bindSlideshowNavCompactDismissGlobalsOnce();
    scan(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    setTimeout(onReady, 0);
  }

  if (document.body) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) {
            return;
          }
          if (node.matches && node.matches("product-card")) {
            initCard(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll("product-card").forEach((c) => initCard(c));
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
